import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const RefundIdSchema = z.string().brand<'refund-id'>()

export type RefundId = ZodInfer<typeof RefundIdSchema>

export const RefundId = (value: string = generateRandomString()) => {
  return RefundIdSchema.parse(value)
}
